module.exports = __webpack_public_path__ + "img/freelance-jobs.cd904bca.jpg";